import { useTranslation } from 'react-i18next';

import AddContractModal from '../../../styledComponents/Modals/AddContractModal/AddContractModal';
import FormErrorProvider from '../../../styledComponents/FormErrorProvider/FormErrorProvider';
import Header from '../../../styledComponents/PageDetails/HeaderPageDetails/HeaderPageDetails';
import { SubscriptionPricingFormFields } from '../../../styledComponents/SubscriptionFormPage/FormSections/AirAmbulanceSubscription/SubscriptionPricingForm/subscriptionPricingForm.models';
import { useEditDOCSubscriptionPage } from './editDOCSubscriptionPage.hooks';
import EditDOCSubscriptionForm from './EditDOCSubscriptionForm/EditDOCSubscriptionForm';

const EditDOCSubscriptionPage = () => {
  const { t } = useTranslation();
  const {
    organizationName,
    subscriptionType,
    loadDatesForNewSubscriptionHandler,
  } = useEditDOCSubscriptionPage();

  return (
    <FormErrorProvider
      initErrorGroups={[SubscriptionPricingFormFields.Pricing]}
    >
      <AddContractModal />
      <Header
        title={t('headers.edit-product-subscription', {
          organizationName,
          subscriptionType,
        })}
      />

      <EditDOCSubscriptionForm
        onContractChanged={loadDatesForNewSubscriptionHandler}
      />
    </FormErrorProvider>
  );
};

export default EditDOCSubscriptionPage;
